'use client';
import React, { useState, useEffect } from 'react';
import { WishlistButton as SharedWishlistButton } from '@launchstore/shared-puck';
import type {
  WishlistButtonProps, CheckWishlistAuth, IsVariantWishlisted, ToggleWishlist,
} from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import { useWishlist } from '@/lib/hooks/useWishlist';
import type { ProductData } from '@launchstore/shared-puck';

const toProductData = (p: any): ProductData | null => {
  if (!p) return null;
  return {
    id: p.id, title: p.title,
    variants: (p.variants || []).map((v: any) => ({ id: v.id, sku: v.sku })),
  };
};

const SharedWishlistButtonRender = (SharedWishlistButton as any).render;

const WishlistButtonImpl: React.FC<WishlistButtonProps> = (props: any) => {
  const { product, selectedVariant } = useProduct();
  const { isInWishlist: inListFn, toggleItem, isLoading: wishlistLoading } = useWishlist() as any;

  const checkAuth: CheckWishlistAuth = async () => {
    try {
      const res = await fetch('/api/auth/check');
      if (!res.ok) return false;
      const data = await res.json();
      return !!data?.authenticated;
    } catch { return false; }
  };
  const inList: IsVariantWishlisted = (variantId) => {
    if (typeof inListFn === 'function') return inListFn(variantId);
    return false;
  };
  const toggle: ToggleWishlist = async (variantId) => {
    if (typeof toggleItem === 'function') await toggleItem(variantId);
  };

  return (
    <SharedWishlistButtonRender
      {...(props as any)}
      product={toProductData(product)}
      selectedVariantId={selectedVariant?.id ?? product?.variants?.[0]?.id ?? null}
      checkAuth={checkAuth}
      isInWishlist={inList}
      toggleWishlist={toggle}
      wishlistLoading={!!wishlistLoading}
    />
  );
};

export const WishlistButton: any = { ...SharedWishlistButton, render: (props: any) => <WishlistButtonImpl {...props} /> };
export default WishlistButton;
